import React from "react";
import { useTranslation } from "react-i18next";
import { UserLoginErrorCode } from "../../generated/graphql";
import { BANNER_TYPES } from "../Common/__styles__/Banner";
import Banner from "../Common/Banner";
import { Button } from "../Common/Button";

export const ErrorMessage = ({
  error,
  onClickPasswordReset,
}: {
  error: { message: string; code?: UserLoginErrorCode };
  onClickPasswordReset?: () => void;
}) => {
  const { t } = useTranslation();

  switch (error.code) {
    case UserLoginErrorCode.INCORRECT_USERNAME_OR_PASSWORD: {
      return (
        <ErrorMessageBanner>
          {t("sign-in-incorrect-username-or-password")}
        </ErrorMessageBanner>
      );
    }
    case UserLoginErrorCode.MISSING_EMAIL_OR_PASSWORD: {
      return (
        <ErrorMessageBanner>
          {t("sign-in-invalid-username-or-password")}
        </ErrorMessageBanner>
      );
    }
    case UserLoginErrorCode.PASSWORD_EXPIRED: {
      if (onClickPasswordReset) {
        return (
          <ErrorMessageBanner>
            Your password has expired. Please{" "}
            <Button
              type="button"
              onClick={onClickPasswordReset}
              styleVariant="buttonLink"
              size="small"
              style={{ display: "inline-block" }}
              data-testid="password-reset-button"
            >
              {t("sign-in-password-expired-link")}
            </Button>{" "}
            or contact support@withforerunner.com for assistance.
          </ErrorMessageBanner>
        );
      }
      return (
        <ErrorMessageBanner>{t("sign-in-password-expired")}</ErrorMessageBanner>
      );
    }
    case UserLoginErrorCode.UNEXPECTED_ERROR: {
      return (
        <ErrorMessageBanner>{t("sign-in-unexpected-error")}</ErrorMessageBanner>
      );
    }
    default: {
      return <ErrorMessageBanner>{error.message}</ErrorMessageBanner>;
    }
  }
};

export const ErrorMessageBanner = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <Banner type={BANNER_TYPES.CRITICAL}>{children}</Banner>;
};
